import type { TablerIconsProps } from '@tabler/icons-react';
import {
	IconActivity,
	IconBolt,
	IconChartBar,
	IconCloudNetwork,
	IconCode,
	IconFile,
	IconHeadset,
	IconHistory,
	IconKey,
	IconLine,
	IconListDetails,
	IconLoader2,
	IconMessages,
	IconPlugConnected,
	IconShieldLock,
	IconSparkles,
	IconUserEdit,
	IconUserScan,
} from '@tabler/icons-react';

export const PLANS = ['secoda-ai', 'core', 'premium', 'enterprise'];
export const PLAN_FEATURE_CATEGORIES = ['includes'];
export type PLAN_FEATURE_ITEM = {
	label: string;
	icon: (props: TablerIconsProps) => JSX.Element;
};
export const PLAN_FEATURES: {
	[key: (typeof PLANS)[number]]: {
		[key: (typeof PLAN_FEATURE_CATEGORIES)[number]]: PLAN_FEATURE_ITEM[];
	};
} = {
	'secoda-ai': {
		includes: [
			{
				label: '$20 included credits for Secoda AI per month',
				icon: IconSparkles,
			},
			{
				label: 'Limited integrations',
				icon: IconPlugConnected,
			},
			{
				label: 'Q&A management',
				icon: IconMessages,
			},
			{
				label: 'Slack integration',
				icon: IconMessages,
			},
			{
				label: 'AI personas and filters',
				icon: IconUserScan,
			},
			{
				label: 'Light data catalog',
				icon: IconListDetails,
			},
			{
				label: 'Data glossary',
				icon: IconFile,
			},
			{
				label: 'Data documentation',
				icon: IconFile,
			},
			{
				label: 'SSO',
				icon: IconKey,
			},
		],
	},
	core: {
		includes: [
			{
				label: '$50 included credits for Secoda AI per month',
				icon: IconSparkles,
			},
			{
				label: 'Column and table-level lineage',
				icon: IconLine,
			},
			{
				label: 'Up to 500 data monitors',
				icon: IconActivity,
			},
			{
				label: 'Full data catalog',
				icon: IconListDetails,
			},
			{
				label: 'Access to all integrations',
				icon: IconPlugConnected,
			},
			{
				label: 'Automations',
				icon: IconBolt,
			},
			{
				label: 'API access',
				icon: IconCode,
			},
			{
				label: 'Home page and inbox',
				icon: IconFile,
			},
			{
				label: 'Workspace analytics',
				icon: IconChartBar,
			},
			{
				label: 'SAML',
				icon: IconKey,
			},
			{
				label: 'SSH / Reverse SSH',
				icon: IconCloudNetwork,
			},
			{
				label: 'Push integrations',
				icon: IconPlugConnected,
			},
		],
	},
	premium: {
		includes: [
			{
				label: '$100 included credits for Secoda AI per month',
				icon: IconSparkles,
			},
			{
				label: 'Up to 1,000 data monitors',
				icon: IconActivity,
			},
			{
				label: 'Data Quality Score',
				icon: IconLoader2,
			},
			{
				label: 'Access request management',
				icon: IconUserEdit,
			},
			{
				label: 'Policies',
				icon: IconShieldLock,
			},
			{
				label: 'Single-tenant deployment',
				icon: IconShieldLock,
			},
			{
				label: 'PII scanning',
				icon: IconUserScan,
			},
			{
				label: 'VPC peering',
				icon: IconCloudNetwork,
			},
			{
				label: 'Premium support',
				icon: IconHeadset,
			},
		],
	},
	enterprise: {
		includes: [
			{
				label: '$200 included credits for Secoda AI per month',
				icon: IconSparkles,
			},
			{
				label: 'RBAC',
				icon: IconShieldLock,
			},
			{
				label: 'Custom roles',
				icon: IconUserEdit,
			},
			{
				label: 'Self-hosted deployment',
				icon: IconShieldLock,
			},
			{
				label: 'Up to 2,000 data monitors',
				icon: IconActivity,
			},
			{
				label: 'Dedicated support',
				icon: IconHeadset,
			},
			{
				label: 'Access requests',
				icon: IconUserEdit,
			},
			{
				label: 'SIEM logging',
				icon: IconHistory,
			},
			{
				label: 'Unlimited integrations',
				icon: IconPlugConnected,
			},
			{
				label: 'Disaster recovery support',
				icon: IconShieldLock,
			},
			{
				label: 'Professional services',
				icon: IconHeadset,
			},
		],
	},
};
